import { ReceivedInvoiceAiSuggestStatusProperty } from '@/context/services/invoice/type';
import {
  hasAiSuggestResult,
  isAiSuggestSuccess,
} from '@/features/invoices/utils/aiSuggestStatus';
import { usePaymentRequestSupportAgentFlag } from '@/hooks/feature_flag/usePaymentRequestSupportAgentFlag';
import { useTranslation } from '@/i18n';
import { IconAi, IconCaution, Tag } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './AiSuggestTag.module.scss';

const cx = classnames.bind(styles);

export type AiSuggestTagProps = {
  aiSuggestStatus?: ReceivedInvoiceAiSuggestStatusProperty;
};

/**
 * AIサジェスト status tag for the received-invoice detail drawer.
 * Renders only when the feature flag is on and AI Suggest produced a result
 * (success → blue + IconAi, failure → yellow + IconCaution), otherwise null.
 */
export const AiSuggestTag: FC<AiSuggestTagProps> = memo(
  ({ aiSuggestStatus }) => {
    const { t } = useTranslation();
    const isAiSuggestLabelEnabled = usePaymentRequestSupportAgentFlag();

    if (!isAiSuggestLabelEnabled || !hasAiSuggestResult(aiSuggestStatus)) {
      return null;
    }

    const isSuccess = isAiSuggestSuccess(aiSuggestStatus);

    return (
      <span>
        <Tag
          status={isSuccess ? 'success' : 'warning'}
          closable={false}
          outline={false}
          size='default'
          className={cx(styles['aiSuggestTag'])}
          customIcon={
            isSuccess ? <IconAi size={12} /> : <IconCaution size={12} />
          }
        >
          {t('received_invoice.ai_suggest_label')}
        </Tag>
      </span>
    );
  }
);
AiSuggestTag.displayName = 'AiSuggestTag';
